import React from 'react';

const BigAudio = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4241_24675)'>
        <path
          d='M20.0007 23.334C22.7673 23.334 25.0007 21.1007 25.0007 18.334V8.33398C25.0007 5.56732 22.7673 3.33398 20.0007 3.33398C17.234 3.33398 15.0007 5.56732 15.0007 8.33398V18.334C15.0007 21.1007 17.234 23.334 20.0007 23.334ZM18.334 8.33398C18.334 7.41732 19.084 6.66732 20.0007 6.66732C20.9173 6.66732 21.6673 7.41732 21.6673 8.33398V18.334C21.6673 19.2507 20.9173 20.0007 20.0007 20.0007C19.084 20.0007 18.334 19.2507 18.334 18.334V8.33398ZM28.334 18.334C28.334 22.934 24.6007 26.6673 20.0007 26.6673C15.4007 26.6673 11.6673 22.934 11.6673 18.334H8.33398C8.33398 24.2173 12.684 29.0506 18.334 29.8673V35.0007H21.6673V29.8673C27.3173 29.0506 31.6673 24.2173 31.6673 18.334H28.334Z'
          fill='#5A5955'
        />
      </g>
      <defs>
        <clipPath id='clip0_4241_24675'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BigAudio;
